export enum Brand {
	buick = 'buick',
	cadillac = 'cadillac',
	chevrolet = 'chevrolet',
	chevroletEV = 'chevroletEV',
	gmc = 'gmc',
	crossbrand = 'GM',
	celestiq = 'celestiq',
	ultium = 'ultium',
	multibrand = 'multibrand',
}

/**
 * Union type representing all possible brand values as string literals.
 * Automatically derived from the Brand enum to ensure type safety and maintainability.
 * Used for type-safe brand identification throughout the application.
 */
export type BrandType = `${Brand}`
